import React from "react";

import {
  PrimaryBlockType,
  PrimaryBlockConfig,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  getDefaultProps,
  primaryBlock,
  MediaProp,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import { Variants } from "@kameleon-util/global-theme";
import { LayoutProps } from "../types/prop-types";
import defaults from "../defaults.json";

export type ContentCollectionItemType = {
  /** Place prop documentation here */
  title?: string;
  description?: string;
  subject?: string;
  image?: MediaProp;
  _index: number;
  _isActive: boolean;
  _accordionId?: string;
  _columnId?: string;
} & PrimaryBlockType<LayoutProps>;

/** ContentCollectionItem PrimaryCollection */
export const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.Medium,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const ContentCollectionItem = primaryBlock<ContentCollectionItemType>(
  blockConfig,
  ({
    SecondaryBlock,
    title,
    description,
    subject,
    image,
    _index,
    _isActive,
    _columnId,
  }: ContentCollectionItemType) => {
    const isActiveClass = _isActive ? "active" : "";

    return (
      <Variants.AccordionHorizontal className="layout351_accordion_container">
        <Variants.LinkHeading
          data-w-id={_columnId}
          className="layout351_column"
        >
          <Variants.Heading as="h5" className="layout351_column-text">
            0{_index ? _index + 1 : 1}
          </Variants.Heading>
          <Variants.Heading
            as="h3"
            variant="h5"
            className="layout351_column-vertical-text"
          >
            {subject}
          </Variants.Heading>
          <Variants.Heading
            as="h3"
            variant="h5"
            className="layout351_column-horizontal-text"
          >
            {subject}
          </Variants.Heading>
        </Variants.LinkHeading>
        <Box className={`layout351_column-content ${isActiveClass}`}>
          <Box className="layout351_content-wrapper">
            <Box className="margin-bottom margin-small">
              <Variants.Heading as="h3">{title}</Variants.Heading>
            </Box>
            <Variants.ParagraphMedium>{description}</Variants.ParagraphMedium>
            {renderSecondaryBlock(SecondaryBlock)}
            <Box className="margin-top margin-large layout351_image-wrapper">
              <Variants.Image
                src={image?.url}
                loading="lazy"
                alt={image?.alt}
                className="layout351_image"
              />
            </Box>
          </Box>
        </Box>
      </Variants.AccordionHorizontal>
    );
  }
);

const defaultContentProp = {
  ...defaults.contentProps.PrimaryBlocks[0],
  _isActive: true,
  _index: 0,
};

const itemDefaults = {
  layoutProps: defaults.layoutProps,
  contentProps: defaultContentProp,
};
ContentCollectionItem.defaultProps =
  getDefaultProps<ContentCollectionItemType>(itemDefaults);
